import type {TMajorActionData} from '@kapitalist/contract/types'
import type {TSkin} from '~/game/skins'
import {DataBackedModel} from '~/models/base'
import type GamePosition from '~/models/game/GamePosition'
import type {Tense} from '~/utils/language'

export type TMajorActionUserFacingDescriptionData = {
  gamePosition: GamePosition
  tense: Tense
  skin: TSkin
}

// extra data from e.g. GamePosition that all MajorActions need when being constructed.
// type TMajorActionConstructorContext = {
//   portfolios: Portfolio[] // all the portfolios on the table when the major action was taken
// }

export default abstract class MajorAction<
  D extends TMajorActionData = TMajorActionData,
>
  extends DataBackedModel<D>
  implements Pick<D, 'type'>
{
  // public id: string
  public type: D['type']

  constructor(
    data: D // , context: TMajorActionConstructorContext
  ) {
    super(data)
    // this.id = data.id
    this.type = data.type
  }

  public abstract userFacingDescription(
    data: TMajorActionUserFacingDescriptionData
  ): string
}
